import * as React from "react";
import { Statisic } from "../../components/Statistic";
import { ALBUM, AUDIO, DOWNLOAD } from "../../assets";
import { BPMAnalyticsAPI } from "../../api";
import { FilterContextType, FilterParams } from "../../components/context/filter";
import { SessionChart } from "./charts/SessionChart";
import { DownloadStatisticChart } from "./charts/DownloadStatisticChart";
import { StreamChart } from "./charts/StreamChart";
import { MembershipChart } from "./charts/MembershipChart";
import { DownloadChart } from "./charts/DownloadChart";
import { CumulativeSubscriptionChart } from "./charts/CumulativeSubscriptionChart";
import { ScrollView } from "../../components/ScrollView";
import { PlatformRenderer, sp } from "../../utils/platformSelect";
import { PlatformContextConsumer } from "../../components/context/platform";
import { OneTimePurchasesChart } from "./charts/OneTimePurchasesChart";

interface StatisticState {
    streams: number
    media: number
    albums: number
    users: number
    searches: number
    views: number
}
interface DashboardState {
    statistics?: StatisticState
}
export class Dashboard extends React.Component<{}, DashboardState> {

    static contextType = FilterContextType

    context: FilterParams
    previousContext: FilterParams;

    constructor(p: any) {
        super(p);
        this.state = {

        }
    }

    componentDidUpdate() {
        if (this.previousContext !== this.context) {
            this.loadData();
        }
        this.previousContext = this.context;
    }

    componentDidMount() {
        this.previousContext = this.context;
        this.loadData()
    }

    loadData() {
        this.setState({ statistics: undefined })
        BPMAnalyticsAPI.get<StatisticState>('statistics', this.context).then((stats) => {
            this.setState({ statistics: stats })
        })
    }

    render() {
        return <PlatformContextConsumer>{platform =>
            <div className='dashboard'>
                <div className='statistics'>
                    <ScrollView>
                        <DownloadStatisticChart />
                        <Statisic title={`${sp(platform, { default: 'Albums', create: 'Soundpacks' })} Added`} icon={ALBUM} value={this.state.statistics ? this.state.statistics.albums : undefined} />
                        <Statisic title={`${sp(platform, { default: 'Media', create: 'Sounds' })} Added`} icon={AUDIO} value={this.state.statistics ? this.state.statistics.media : undefined} />
                        <Statisic title='Total Streams' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.streams : undefined} />
                        <Statisic title='Users Registered' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.users : undefined} />
                        <Statisic title='Total Pageviews' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.views : undefined} />
                        <Statisic title='Total Searches' icon={DOWNLOAD} value={this.state.statistics ? this.state.statistics.searches : undefined} />
                    </ScrollView>
                </div>
                <div className='charts'>
                    <div className='bpm-container'>
                        <div className='row'>
                            <div className='col'>
                                <StreamChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col' style={{ flex: 3 }}>
                                <SessionChart />
                            </div>
                            <div className='col'>
                                <MembershipChart type='membership' />
                            </div>
                            <PlatformRenderer only='create'>
                                <div className='col'>
                                    <MembershipChart type='one-time-purchases' />
                                </div>
                            </PlatformRenderer>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <DownloadChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <CumulativeSubscriptionChart />
                            </div>
                        </div>
                        <PlatformRenderer only='create'>
                            <div className='row'>
                                <div className='col'>
                                    <OneTimePurchasesChart />
                                </div>
                            </div>
                        </PlatformRenderer>
                    </div>

                </div>
            </div>
        }</PlatformContextConsumer>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard.tsx